import ApiEndpoints from '../../../utils/ApiEndpoints';
import { apiGet } from '../../../utils/apiRequests';
import {
  HOLES_INDEX_PAR_LOADING,
  HOLES_INDEX_PAR_SUCCESS,
  HOLES_INDEX_PAR_ERROR,
  CLEAR_HOLES_INDEX_PAR,
} from '../../../constant/actionTypes';

export const getCourseIndexPar = (courseId) => (dispatch) => {
  dispatch({ type: HOLES_INDEX_PAR_LOADING });

  apiGet(
    `${ApiEndpoints.course.base}${ApiEndpoints.course.getParIndex}/${courseId}`,
    (response) => {
      if (response.error == true) {
        dispatch({
          type: HOLES_INDEX_PAR_ERROR,
          response: response.message,
        });
      } else {
        dispatch({ type: HOLES_INDEX_PAR_SUCCESS, response: response });
      }
    },
    (error) => {
      dispatch({ type: HOLES_INDEX_PAR_ERROR, response: error });
    }
  );
};

export const clearIndexParList = () => (dispatch) => {
  dispatch({ type: CLEAR_HOLES_INDEX_PAR });
};
